module.exports = __webpack_public_path__ + "static/fonts/GroteskDemiBold.cc8e2cb.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/GroteskDemiBold.ttf
// module id = m9ci
// module chunks = 0